import {IComponentOptions} from "angular";
import "./application-comments.less";

export const ApplicationCommentsComponent: IComponentOptions = {
    bindings: {
        application: "<",
        firebaseDatabasePath: "<",
        currentUser: "<"
    },
    template: require("./application-comments.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/comments/application-comments.component.ts